import { useCallback } from "react";
import { useMutation, useQueryClient } from "react-query";
import { Api } from "src/apis/helpers/configs/api";
import { StandardsService } from "src/apis/services/standards/standardsService";
import { StandardsDto } from "src/data/models/standardsDtos/standardsDto.interface";
import { container } from "tsyringe";

export const useAddStandards = () => {
    const standardsService = container.resolve(StandardsService);
    const queryClient = useQueryClient();

    const toggleAddStandards = useCallback(
        (data, variables, context) => {
            let lastData = queryClient.getQueryData<Array<StandardsDto>>([Api.Standards.getStandards]);
            const finalData = [...lastData] ;
            finalData.push(data);
            lastData = finalData ;
            queryClient.setQueryData([Api.Standards.getStandards],lastData )
        },
        [],
    );
    return useMutation({
        mutationFn: (data: StandardsDto) => {
            return standardsService.addStandards(data);
        },
        onSuccess: toggleAddStandards
    })

}
